import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useEffect, useCallback } from "react";
import classnames from "classnames";
import { SOLUTION_GALERY_ITEM_CLICKED, SOLUTION_GALERY_VIDEO_INTERACTION } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { StyledAssetGallery } from "./asset-gallery.scss";
export const ASSET_TYPE_IMAGE = "image";
export const ASSET_TYPE_VIDEO = "video";
const VIDEO_PLAY = "video_play";
const VIDEO_PAUSE = "video_pause";
const VIDEO_ENDED = "video_ended";
const PLAY_VIDEO_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/template-store/template-page/play.png";
const AssetGallery = ({ assets })=>{
    const [isScrolledUntilBottom, setIsScrolledUntilBottom] = useState(false);
    const [selectedAssetIndex, setSelectedAssetIndex] = useState(0);
    const sideGalleryRef = useRef();
    useEffect(()=>{
        var _sideGalleryRef_current;
        const handleScroll = ()=>{
            const { offsetHeight, scrollTop, scrollHeight } = sideGalleryRef.current;
            const isScrolledToBottom = offsetHeight + scrollTop >= scrollHeight;
            setIsScrolledUntilBottom(isScrolledToBottom);
        };
        (_sideGalleryRef_current = sideGalleryRef.current) === null || _sideGalleryRef_current === void 0 ? void 0 : _sideGalleryRef_current.addEventListener("scroll", handleScroll);
        return ()=>{
            var _sideGalleryRef_current;
            return (_sideGalleryRef_current = sideGalleryRef.current) === null || _sideGalleryRef_current === void 0 ? void 0 : _sideGalleryRef_current.removeEventListener("scroll", handleScroll);
        };
    }, [
        isScrolledUntilBottom
    ]);
    const selectAsset = useCallback((index)=>{
        var _assets_index;
        trackEvent(SOLUTION_GALERY_ITEM_CLICKED, {
            kind: (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.type,
            info1: index,
            info2: assets.length
        });
        setSelectedAssetIndex(index);
    }, [
        assets
    ]);
    /*
    Renderers
  */ const renderSideImagesOverlayIfNeeded = useCallback(()=>{
        if (isScrolledUntilBottom) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: "preview-side-images-bottom-overlay"
        });
    }, [
        isScrolledUntilBottom
    ]);
    const renderPlayIcon = ()=>{
        return /*#__PURE__*/ _jsx("img", {
            className: "video-thumbnail-icon",
            src: PLAY_VIDEO_IMG_SRC
        });
    };
    const onVideoInteraction = (asset, actionType)=>{
        trackEvent(SOLUTION_GALERY_VIDEO_INTERACTION, {
            kind: actionType,
            info1: asset.src
        });
    };
    const renderAssetIndex = useCallback((assetIndex, isMain = false)=>{
        const className = isMain ? "main-asset" : "preview-asset";
        const asset = assets[assetIndex];
        if (asset.type === ASSET_TYPE_VIDEO) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("video", {
                        className: className,
                        src: asset.src,
                        controls: isMain,
                        onPlay: ()=>onVideoInteraction(asset, VIDEO_PLAY),
                        onEnded: ()=>onVideoInteraction(asset, VIDEO_ENDED),
                        onPause: ()=>onVideoInteraction(asset, VIDEO_PAUSE)
                    }),
                    !isMain && renderPlayIcon()
                ]
            });
        }
        return /*#__PURE__*/ _jsx("img", {
            className: className,
            src: asset.src,
            alt: asset.title
        });
    }, [
        assets
    ]);
    const renderPreviewAssets = useCallback(()=>{
        return assets.map((asset, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("preview-asset-wrapper", {
                    selected: index === selectedAssetIndex
                }),
                onClick: ()=>selectAsset(index),
                children: renderAssetIndex(index)
            }, index);
        });
    }, [
        assets,
        selectedAssetIndex,
        selectAsset,
        renderAssetIndex
    ]);
    const renderNewAssets = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "asset-gallery",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "main-asset-wrapper",
                    children: renderAssetIndex(selectedAssetIndex, true)
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "assets-previews-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "previews-container",
                            ref: sideGalleryRef,
                            children: renderPreviewAssets()
                        }),
                        renderSideImagesOverlayIfNeeded()
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx(StyledAssetGallery, {
        className: "asset-gallery",
        children: renderNewAssets()
    });
};
export default AssetGallery;
